import React, { useState, useEffect, useRef } from "react";

import ReactPlayer from "react-player";

import { HeroData } from "data/classes";
import { Button, useClickOuter } from "studio-design-system";

import { ModalCloseButton } from "~/components/classLanding/components/HeroSection/ClassTrailerVideoModal/ModalCloseButton";
import { DEFAULT_WISTIA_OPTIONS } from "~/components/classLanding/components/HeroSection/ClassTrailerVideoModal/constants";
import { useKeyDown } from "~/hooks/useKeyDown";
import { isSafari } from "~/util/isSafari";
import { onKeyDownVideo } from "~/util/onKeyDownVideo";

import * as styles from "./ClassVideoModal.css";

interface ClassVideoModalProps {
  isTrailerVideoOpen: boolean;
  toggleVideoModal: () => void;
  videoUrl: string;
}

export const ClassVideoModal = ({
  videoUrl,
  isTrailerVideoOpen,
  toggleVideoModal,
}: ClassVideoModalProps): React.ReactElement => {
  const [shouldPauseVideo, setShouldPauseVideo] = useState(false);
  const [shouldPlayVideo, setShouldPlayVideo] = useState(!isSafari());

  const outerClickRef = useClickOuter(true, () => {
    if (isTrailerVideoOpen) {
      toggleVideoModal();
    }
  });
  const reactPlayerVideoLessonOptions = { wistia: DEFAULT_WISTIA_OPTIONS };
  const videoPlayer = useRef<ReactPlayer>(null);

  useKeyDown("Escape", toggleVideoModal, isTrailerVideoOpen);

  useEffect(() => {
    if (isTrailerVideoOpen) {
      if (!isSafari()) {
        setShouldPlayVideo(true);
      }
    } else {
      setShouldPlayVideo(false);
    }
  }, [isTrailerVideoOpen]);

  if (!isTrailerVideoOpen) {
    return <></>;
  }

  return (
    <div
      style={{
        display: isTrailerVideoOpen ? "block" : "none",
        opacity: isTrailerVideoOpen ? "1" : "0",
        pointerEvents: isTrailerVideoOpen ? "auto" : "none",
      }}
      className={styles.trailerVideoModalOverlay}
    >
      <ModalCloseButton className={styles.trailerModalX} onClick={toggleVideoModal} />
      <div
        style={{ pointerEvents: isTrailerVideoOpen ? "inherit" : "none" }}
        className={styles.trailerVideoModalContainer}
      >
        <div className={styles.trailerVideoModal} ref={outerClickRef}>
          <div className={styles.trailerVideoPlayerProportionContainer}>
            <div className={styles.trailerVideoPlayerContainer}>
              <ReactPlayer
                ref={videoPlayer}
                width="100%"
                height="100%"
                config={reactPlayerVideoLessonOptions}
                playing={shouldPlayVideo && !shouldPauseVideo}
                onPlay={() => setShouldPauseVideo(false)}
                onInterrupt={() => setShouldPauseVideo(true)}
                className={styles.trailerVideo}
                url={videoUrl}
                onKeyDown={(event: React.KeyboardEvent<HTMLElement>) =>
                  onKeyDownVideo(videoPlayer, event)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
